var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0C4.92529 0 0 4.92707 0 11C0 17.0765 4.92529 22 11 22C17.0747 22 22 17.0765 22 11C22 4.92707 17.0747 0 11 0ZM11 4.87903C12.0289 4.87903 12.8629 5.71308 12.8629 6.74193C12.8629 7.77079 12.0289 8.60484 11 8.60484C9.97114 8.60484 9.1371 7.77079 9.1371 6.74193C9.1371 5.71308 9.97114 4.87903 11 4.87903ZM13.4839 16.1452C13.4839 16.4391 13.2456 16.6774 12.9516 16.6774H9.04839C8.75445 16.6774 8.51613 16.4391 8.51613 16.1452V15.0806C8.51613 14.7867 8.75445 14.5484 9.04839 14.5484H9.58064V11.7097H9.04839C8.75445 11.7097 8.51613 11.4714 8.51613 11.1774V10.1129C8.51613 9.81896 8.75445 9.58064 9.04839 9.58064H11.8871C12.181 9.58064 12.4194 9.81896 12.4194 10.1129V14.5484H12.9516C13.2456 14.5484 13.4839 14.7867 13.4839 15.0806V16.1452Z",
    fill: "#3272BE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.9ff1beca8667d05a14d1e5694d9e3d12.svg";
export { ForwardRef as ReactComponent };